module.exports = __webpack_public_path__ + "img/activity3-2.707a9178.png";